import type { ReactNode } from 'react';

export const symbol_no_backpack: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M650-880q12.75 0 21.38 8.62Q680-862.75 680-850v54q51 9 85.5 49.5T800-650v345q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-345q0-38-26-64t-64-26H305l-7-7q-8-8-13-19.28-5-11.28-5-23.72v-60q0-12.75 8.63-21.38Q297.25-880 310-880h40q12.75 0 21.38 8.62Q380-862.75 380-850v50h200v-50q0-12.75 8.63-21.38Q597.25-880 610-880h40ZM490-470l60 60H310q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h180Zm39-46Zm-53 117ZM204-756l42 42q-12 12-19 28.39T220-650v510h520v-80l60 60v20q0 24.75-17.62 42.37Q764.75-80 740-80H220q-24.75 0-42.37-17.63Q160-115.25 160-140v-510q0-32 12-59t32-47ZM792-83 82-792q-9-8.5-9-21.25T81.61-835q9.39-9 21.86-9 12.46 0 21.53 9l710 710q9 9 9 21t-9 21q-9 9-21.5 9T792-83Z"
		/>
	</svg>
);
